import type { Location } from "react-router-dom";

/** A query param rather than router state, because editors rewrite their query with `replace`, which drops state. */
const RETURN_TO_PARAM = "returnTo";

/** Where a flow editor's Close goes; only in-app paths, so the param can't redirect off-site. */
export function flowEditorReturnTo(search: string): string | undefined {
  const returnTo = new URLSearchParams(search).get(RETURN_TO_PARAM);
  return returnTo?.startsWith("/") && !returnTo.startsWith("//")
    ? returnTo
    : undefined;
}

function withReturnTo(to: string, returnTo: string | undefined): string {
  return returnTo
    ? `${to}?${new URLSearchParams({ [RETURN_TO_PARAM]: returnTo })}`
    : to;
}

/** Link into a flow editor whose Close comes back to the current page. */
export function flowEditorLinkFrom(to: string, location: Location): string {
  return withReturnTo(to, location.pathname + location.search);
}

/** Link to a sibling flow editor that keeps the current editor's Close destination. */
export function siblingFlowEditorLink(to: string, location: Location): string {
  return withReturnTo(to, flowEditorReturnTo(location.search));
}
